import mapboxgl from "mapbox-gl";

/**
 * True if this browser/device cannot run Mapbox GL (no WebGL).
 * Writes a notice into the map container instead of letting mapbox-gl throw.
 */
export function mapboxUnsupported(containerId) {
    if (mapboxgl.supported()) {
        return false;
    }

    const container = document.getElementById(containerId);

    if (container) {
        container.innerHTML = `
            <div class="flex h-full min-h-[16rem] w-full items-center justify-center bg-gray-50 p-6 dark:bg-gray-800">
                <div class="flex max-w-sm flex-col items-center gap-3 text-center">
                    <span class="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 dark:bg-gray-700">
                        <svg class="h-6 w-6 text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                            <path stroke-linecap="round" d="m3 3 18 18" />
                        </svg>
                    </span>
                    <p class="text-base font-semibold text-gray-700 dark:text-gray-200">Map not available</p>
                    <p class="text-sm text-gray-500 dark:text-gray-400">This browser or device does not support WebGL.</p>
                    <p class="text-sm font-bold text-gray-800 dark:text-gray-100">Please update your internet browser to the latest version and try again.</p>
                </div>
            </div>
        `;
    }

    return true;
}
